import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCheckCircle, faFileAlt } from '@fortawesome/free-solid-svg-icons';

interface SummaryWidgetsProps {
  type: 'individual' | 'organization';
  stakeholderData: any;
  openMatters: number;
  totalMatters: number;
  formatDate: (date: string | Date | null | undefined) => string;
  useProjectsLabel?: boolean;
}

const SummaryWidgets: React.FC<SummaryWidgetsProps> = ({
  type,
  stakeholderData,
  openMatters,
  totalMatters,
  formatDate,
  useProjectsLabel = false,
}) => {
  const entityLabel = useProjectsLabel ? 'Projects' : 'Matters';
  return (
    <div className="stakeholder-summary-widgets">
      <div className="stakeholder-widget">
        <div className="stakeholder-widget-icon badge-green">
          <FontAwesomeIcon icon={faCheckCircle} />
        </div>
        <div className="stakeholder-widget-content">
          <div className="stakeholder-widget-label">Status</div>
          <div className="stakeholder-widget-value value-green">
            Active {type === 'organization' ? 'Client' : 'Stakeholder'}
          </div>
        </div>
      </div>
      <div className="stakeholder-widget">
        <div className="stakeholder-widget-icon badge-grey">
          <FontAwesomeIcon icon={faCalendar} />
        </div>
        <div className="stakeholder-widget-content">
          <div className="stakeholder-widget-label">
            {type === 'organization' ? 'Client Since' : 'Stakeholder Since'}
          </div>
          <div className="stakeholder-widget-value value-dark">
            {formatDate(stakeholderData.contact_created_date || stakeholderData.ContactCreatedAt)}
          </div>
        </div>
      </div>
      <div className="stakeholder-widget">
        <div className="stakeholder-widget-icon badge-blue">
          <FontAwesomeIcon icon={faFileAlt} />
        </div>
        <div className="stakeholder-widget-content">
          <div className="stakeholder-widget-label">Open {entityLabel}</div>
          <div className="stakeholder-widget-value value-blue">{openMatters}</div>
        </div>
      </div>
      <div className="stakeholder-widget">
        <div className="stakeholder-widget-icon badge-blue">
          <FontAwesomeIcon icon={faFileAlt} />
        </div>
        <div className="stakeholder-widget-content">
          <div className="stakeholder-widget-label">Total {entityLabel}</div>
          <div className="stakeholder-widget-value value-blue">{totalMatters}</div>
        </div>
      </div>
    </div>
  );
};

export default SummaryWidgets;

